import React, { useEffect } from 'react';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { insertURLParameter, removeURLParameter } from '@Components/Utilities/SandhillsUtility';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';

const AuctionBoardLiveBoardHeader = (props) => {
    const routes = useRecoilValue(atoms.routes);

    useEffect(() => {
        const auctionTimeBoardHeaderProgress = (function () {
            var nProgressFailures = 0;
            var nProgressIntervalID;
            const sUpdateProgressURL = routes.ATBoardProgressUpdate;

            $(document).ready(function () {
                const dStartDateTime = $("#AuctionStartTime").val();

                if (dStartDateTime) {
                    const dCurrentDate = new Date();
                    const dStartTimeToRun = new Date(dStartDateTime);

                    if (dCurrentDate >= dStartTimeToRun) {
                        startProgressProgression();
                    }
                }
            });

            function startProgressProgression() {
                nProgressIntervalID = setInterval(function () { updateProgressBar(); }, 60000);
            }

            function clearTimeOutAndHideBoards() {
                clearInterval(nProgressIntervalID);
                $(".liveboard-links").fadeOut();
            }

            function AddOrReplaceQSValue(sQuerystringKey, sQuerystringValue, sURL) {
                sURL = removeURLParameter(sURL, sQuerystringKey);
                sURL = insertURLParameter(sURL, sQuerystringKey, sQuerystringValue);
                return sURL;
            }

            function updateProgressBar() {
                var oActiveBoardHeaders = $(".active-headers:visible");
                var oBoardPercentageSpan;
                var arrBaseCatIDs = [];

                if (oActiveBoardHeaders.length > 0) {
                    oBoardPercentageSpan = oActiveBoardHeaders.find(".atboard-percentage");

                    if (oBoardPercentageSpan.length > 0) {
                        oBoardPercentageSpan.each(function () {
                            var nBCID = $(this).data('progress-bcid');
                            var oProgressCard = $('#ProgressPercent_' + nBCID);

                            if (nBCID && oProgressCard && oProgressCard[0]) {
                                var nCurrentProgress = oProgressCard[0].getAttribute('data-progress-complete');

                                if (nCurrentProgress != 100) {
                                    arrBaseCatIDs.push(nBCID);
                                } else {
                                    var oCardParent = oProgressCard.parents('a');
                                    if (oCardParent) {
                                        oCardParent.fadeOut();
                                    }
                                }
                            }
                        });

                        if (arrBaseCatIDs.length > 0) {
                            sandhillsRequest({
                                url: sUpdateProgressURL,
                                method: 'post',
                                data: {
                                    BaseCatIDs: arrBaseCatIDs
                                }
                            }).then((data) => {
                                if (data) {
                                    nProgressFailures = 0;

                                    $.each(data, function () {
                                        var ProgressBar = $('#ProgressPercent_' + this.baseCatID);
                                        if (ProgressBar.length > 0 && ProgressBar[0]) {
                                            var HTMLProgress = ProgressBar[0];

                                            HTMLProgress.setAttribute('style', "width:" + this.progresscomplete + "%");
                                            HTMLProgress.setAttribute('data-progress-complete', this.progresscomplete);

                                            var parentElm = ProgressBar.parents('a');
                                            if (parentElm) {
                                                parentElm.prop('title', this.title);
                                            }
                                        }
                                    });
                                }
                            }).catch((error) => {
                                var sURL = new String(window.location);
                                sURL = AddOrReplaceQSValue("BoardHeaderUpdateFailure", 1, sURL);
                                window.location = sURL;
                            });
                        } else {
                            clearTimeOutAndHideBoards();
                        }
                    } else {
                        clearTimeOutAndHideBoards();
                    }
                } else {
                    clearTimeOutAndHideBoards();
                }
            }
        })();
    }, []);

    const LiveBoardTabs = () => {
        return (
            <>
                {props.ActiveBoards.map(board => (
                    <a href={board.CategoryAuctionBoardURL} className="liveboard-link active-headers" style={{ display: board.DisplayUponLoad ? '' : 'none' }} title={`${board.LiveBoardsWithStatus.ItemsSold} ${translator.translate('sandhills.of')} ${board.TotalItemCount} ${translator.translate('sandhills.sold')}`}>
                        <img src={board.LiveBoardsWithStatus.ImageSrc} alt={board.LiveBoardsWithStatus.ImageAltText}></img>
                        <h2> <span>{board.LiveBoardsWithStatus.HeaderText}</span> {translator.translate('sandhills.liveboard')} </h2>
                        <div className="meter pbred atboard-percentage" data-progress-bcid={board.BaseCategoryID}>
                            <span id={`ProgressPercent_${board.BaseCategoryID}`} style={{ width: `${board.LiveBoardsWithStatus.PercentComplete}%` }} data-progress-complete={board.LiveBoardsWithStatus.PercentComplete}></span>
                        </div>
                    </a>
                ))}
            </>
        );
    };

    return (
        <>
            {!props.HideLiveBoardHeader && props.ActiveBoards.length > 0 &&
                <div className="auction-board-liveheaders">
                    <div className="liveboard-links">
                        <div className="at-header-container">
                            <div className="liveboard-heading">
                                <img src={props.AuctionBoardImgUrl} alt={translator.translate('sandhills.tradepubwebsite.mvc.liveauctionboard')} />
                                <a href={props.AuctionBoardURL}>
                                    <div className="icon">
                                        <i className="fas fa-heart" aria-hidden="true"></i>
                                    </div>
                                    <span>{translator.translate('sandhills.viewmywatchlistwithspace')}</span>
                                </a>
                            </div>
                            {LiveBoardTabs()}
                        </div>
                        <input type="hidden" id="AuctionStartTime" value={props.AuctionStartDateTime} />
                    </div>
                </div>
            }
        </>
    );
};

export default AuctionBoardLiveBoardHeader;